module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular-08.4d8fdeb2.ttf";